module.exports = __webpack_public_path__ + "img/1.97475a6a.png";